import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type SkeletonVariant = 'text' | 'card' | 'list';

/** Layout placeholder while content loads. Announces "Memuat" to screen readers. */
@Component({
  selector: 'ds-skeleton-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div role="status">
      <span class="sr-only">{{ loadingLabel() }}</span>
      <div aria-hidden="true">
        @switch (variant()) {
          @case ('text') {
            @for (line of lineArray(); track $index; let last = $last) {
              <span class="bone bone--line" [style.width]="last ? '60%' : '100%'"></span>
            }
          }
          @case ('card') {
            <div class="bone-card">
              <span class="bone bone--block"></span>
              <span class="bone bone--line" style="width: 70%"></span>
              <span class="bone bone--line" style="width: 45%"></span>
            </div>
          }
          @case ('list') {
            @for (line of lineArray(); track $index) {
              <div class="bone-row">
                <span class="bone bone--circle"></span>
                <div class="bone-row__lines">
                  <span class="bone bone--line" style="width: 55%"></span>
                  <span class="bone bone--line" style="width: 85%"></span>
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  `,
  styles: `
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      clip-path: inset(50%);
      overflow: hidden;
    }

    .bone {
      display: block;
      background: var(--color-surface-sunken);
      border-radius: var(--radius-sm);
      animation: bone-pulse 1.4s ease-in-out infinite;
    }

    .bone--line {
      height: 18px;
      margin-bottom: var(--space-3);
    }

    .bone--block {
      height: 140px;
      border-radius: var(--radius-md);
      margin-bottom: var(--space-4);
    }

    .bone--circle {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }

    .bone-card {
      padding: var(--space-4);
      border: 1.5px solid var(--color-border-subtle);
      border-radius: var(--radius-lg);
    }

    .bone-row {
      display: flex;
      gap: var(--space-3);
      padding: var(--space-3) 0;
    }

    .bone-row__lines {
      flex: 1;
    }

    @keyframes bone-pulse {
      0%,
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0.55;
      }
    }
  `,
})
export class SkeletonLoaderComponent {
  variant = input<SkeletonVariant>('text');
  /** Number of lines (text) or rows (list). */
  count = input(3);
  loadingLabel = input('Memuat konten…');

  protected readonly lineArray = computed(() => Array.from({ length: this.count() }));
}
